import type { MessageRender } from "@product/scmp-sdk/dist/types/components/dashboard-widget/display/hooks";
import { useAtomValue } from "jotai";
import { useCallback } from "react";

import { config } from "shared/data";

import { rosettaAtom } from "scmp-app/lib/rosetta";

import { UpdatePaymentMessage } from ".";

export const useUpdatePaymentMessageRender = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);

  const updatePaymentMessageRender = useCallback<MessageRender>(() => {
    if (
      !asyncRosettaState ||
      asyncRosettaState.status === "loading" ||
      asyncRosettaState.status === "not-executed"
    ) {
      return new Promise(() => {});
    }

    const rosettaInstance = asyncRosettaState.result?.instance;
    if (!rosettaInstance || !rosettaInstance.rulesEngine.getOutcome("user.gracePeriod.isActive")) {
      return Promise.resolve(null);
    }

    const expiryDate = rosettaInstance.rulesEngine.getOutcome("user.gracePeriod.expiryDate");
    const isWithinHalf = rosettaInstance.rulesEngine.getOutcome("user.gracePeriod.isWithinHalf");
    const url = `${config.account.scmpAccountHost}/manage/subscription?showFirst=wallet`;

    return Promise.resolve(
      <UpdatePaymentMessage expiryDate={expiryDate} isWithinHalf={isWithinHalf} url={url} />,
    );
  }, [asyncRosettaState]);

  return { updatePaymentMessageRender };
};
